import React from 'react'
import "./VideoCard2.css";
import yoga from "../../assests/video/yoga.mp4";

const VideoCard2 = () => {
  return (
    <>
    <div className='v-card-rights'>
        <div className='v-card-right-right'>
            <h1>GIRL DOING YOGA ON THE SHORE OF THE OCEAN ON THE BEACH</h1>
            <p>There are many variations of passages of have suffered
             alteration in some, by injected humour, or randomised .</p>
        </div>
        <div className='v-card-left-right'>
            <div className='v-box-right'>
                <video src={yoga} autoPlay loop muted/>
                <div className='text-right'>
                    <div className='top-right'>
                        crossfit
                    </div>
                    <div className='btm-right'>
                        train
                    </div>
                </div>
               
               {/* <div className='button1'>
                        <button>read more <i class="fa-solid fa-chevron-right"></i></button>
               </div>
                
           */}
            </div>
        </div>
    </div>
    </>
  )
}

export default VideoCard2